/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconTooltip from '@telus-uds/palette-koodo/build/rn/icons/Tooltip'
import PaletteIconTooltipSymbol from '@telus-uds/palette-koodo/build/rn/icons/TooltipSymbol'
const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inverse: { type: 'variant', values: [ true ] },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    {
      if: { hover: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        iconColor: '#7a3dfc',
        iconScale: 1.25
      }
    },
    {
      if: { inverse: true },
      tokens: { backgroundColor: 'rgba(0, 0, 0, 0)', iconColor: '#ffffff' }
    },
    {
      if: { hover: true, inverse: true },
      tokens: { iconColor: '#ffffff' }
    },
    {
      if: { focus: true, inverse: true },
      tokens: { outerBorderColor: '#ffffff' }
    },
    {
      if: { focus: true, inverse: null },
      tokens: { outerBorderColor: '#000000' }
    },
    {
      if: { inverse: true, pressed: true },
      tokens: {
        backgroundColor: '#ffffff',
        icon: PaletteIconTooltipSymbol,
        iconColor: '#000000',
        outerBorderColor: '#efefef'
      }
    },
    {
      if: { inverse: null, pressed: true },
      tokens: {
        backgroundColor: '#5b2bc2',
        iconColor: '#ffffff',
        outerBorderColor: '#5b2bc2'
      }
    }
  ],
  tokens: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    borderRadius: 32,
    icon: PaletteIconTooltip,
    iconColor: '#000000',
    iconScale: 1,
    iconSize: 16,
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    outerBorderGap: 4,
    outerBorderWidth: 1,
    width: 16
  }
}
export default theme
